import { ReactEditor } from 'slate-react';
import type AhaEditor from '../../AhaEditor';
import type { EditorPlugin } from '../../types/aha-editor';
import './BlurredSelectionPlugin.css';

const BlurredSelectionPlugin: EditorPlugin = {
  name: 'Blurred selection plugin',
  handlers: {
    onBodyBlur: (_, ahaEditor: AhaEditor) => {
      // This relies on the fairly recent (as of July 2025) CSS highlights API.
      // As this is just a visual effect, it is not critical if the browser does
      // not support it.
      if (!CSS.highlights) return;

      const { editor } = ahaEditor;
      if (!editor.selection) return;

      const domRange = ReactEditor.toDOMRange(editor, editor.selection);
      const highlight = new Highlight(domRange);

      CSS.highlights.set('blurred-selection-highlight', highlight);
      return false;
    },
    onBodyFocus: () => {
      if (!CSS.highlights) return;

      CSS.highlights.delete('blurred-selection-highlight');
      return false;
    },
  },
};

export default BlurredSelectionPlugin;
